module.exports = __webpack_public_path__ + "static/img/electronic-seal-trans.384acdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/electronic-seal-trans.png
// module id = vqSl
// module chunks = 0